/* eslint-disable no-unused-expressions */

import React, { useState, useRef, useCallback } from 'react';
import './style.scss';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import Button from '../../Shared/components/controls/Button';
import helpers from '../helpers/index.js';
import clsx from 'clsx';
import { debounce } from '@mui/material';
import SortingComponent from '../Sorting';
import { loader as gqlLoader } from 'graphql.macro';
import { useLazyQuery } from 'react-apollo';
import SearchItem from '../../Shared/components/SearchItem';
import { Text } from '@sitecore-jss/sitecore-jss-react';
const query = gqlLoader('../API/offerListingSearchSuggestionsQuery.graphql'); //query code

/***Component***/
const SearchComponent = (props) => {
  const icon_filterBlue = '/-/media/Project/FAB2/shared/images/icon_filter-blue.svg';

  const [isOpen, setIsOpen] = useState(false);
  const [wordsNotFoundError, setWordsNotFoundError] = useState(false);
  const [dataRetrievedItems, setDataRetrievedItems] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  let summaryText = 'resultsSummary';
  let searchPagination = {
    currentPage: 1,
    itemsPerPage: 7,
  };
  const {
    allFilters,
    setAllFilters,
    firstOfThisMonthDate,
    indexName,
    language,
    offerCategoryId,
    pagination,
    t,
    selectSortValue,
    setSelectSortValue,
    selectSortText,
    setSelectSortText,
    offerCategoryName,
    setMobileFiltersIsToggle,
    isMobile,
    numberOfFilters,
    setNumberOfFilters,
  } = props;
  const sorting = props?.props?.fields?.sorting;
  const shouldRenderSorting = Array.isArray(sorting) && sorting?.length > 0;

  const [getSearchSuggestionsData, {}] = useLazyQuery(
    query,
    {
      fetchPolicy: 'network-only', //to re-search on keyword if its the same entered after deleting it cz sometimes we need this. when pasting the same word
      onCompleted: (data) => {
        if (inputSearchRef?.current?.value === '') {
          return null;
        }

        let items = data?.search?.results?.items;
        if (items?.length <= 0) {
          setWordsNotFoundError(true);
        }

        if (!!items && items?.length > 0) {
          setWordsNotFoundError(false);
          setDataRetrievedItems(items);
          summaryText = items?.length > 0 ? 'resultsSummary' : 'resultSummary';
          setIsOpen(items?.length > 0);
        } else {
          setIsOpen(false);
        }
      },
    },
    []
  );
  const getSearchSuggestions = useCallback(debounce(getSearchSuggestionsData, 500), []);

  const startSearchCharatersLength = 5;
  /***/
  //when changing the keyword we should change 'searchKeyword' in order to get the
  //resutls from the graphql reltated to search 'offerListingSearchFilter.graphql'
  const handleKeywordChange = () => {
    //get the keyword
    let keyword = inputSearchRef?.current?.value?.replace(/\\/g, '');

    setValue(keyword);

    if (keyword === '') {
      setWordsNotFoundError(false);
      setDataRetrievedItems([]);
      setFocusedIndex(-1);
      setIsOpen(false);
      return null;
    } else {
      if (keyword.length >= startSearchCharatersLength) {
        helpers({
          allFilters,
          firstOfThisMonthDate,
          indexName,
          language,
          pagination: searchPagination,
          offerCategoryId,
          keyword,
          getSearchSuggestions,
          isMobile,
          setNumberOfFilters,
        });
        setFocusedIndex(-1);
      }
    }
  };
  //search with graphql only for keywords
  const handleKeywordSearchButtonClick = () => {
    if (focusedIndex !== -1) {
      if(typeof window !== 'undefined') {
        window.location.href = dataRetrievedItems[focusedIndex]?.item?.url;
      }
    } else {
      let keyword = inputSearchRef?.current?.value;
      let refetch = true;

      helpers({
        allFilters,
        setAllFilters,
        firstOfThisMonthDate,
        indexName,
        language,
        pagination,
        offerCategoryId,
        keyword,
        refetch,
        isMobile,
        setNumberOfFilters,
      });

      //close menu after search
      setIsOpen(false);
      setFocusedIndex(-1);
    }
  };

  const handleCancelSearchClick = () => {
    setValue('');
    setFocusedIndex(-1);
    setIsOpen(false);
    setWordsNotFoundError(false);

    let refetch = true;
    helpers({
      allFilters,
      setAllFilters,
      firstOfThisMonthDate,
      indexName,
      language,
      pagination,
      offerCategoryId,
      keyword: '',
      refetch,
      isMobile,
      setNumberOfFilters,
    });
  };
  /***/
  const inputSearchRef = useRef(null);
  const [value, setValue] = useState('');
  const handleKeyUpOnSearchInput = (e) => {
    let maxItems = 6;
    if (dataRetrievedItems.length < 6) {
      maxItems = dataRetrievedItems.length;
    }
    if (!!e && e.key === 'ArrowDown' && focusedIndex + 2 <= maxItems) {
      setFocusedIndex((prev) => prev + 1);
    }
    if (!!e && e.key === 'ArrowUp' && focusedIndex - 1 !== -1) {
      setFocusedIndex((prev) => prev - 1);
    }
  };

  return (
    <>
      <div className="search-wrap-fixer">
        <div className="fixer-wrapper">
          <div className="mobile-sorting-and-filter mobile">
            {/* <div className="category-name flex-it flex-align-item-center">{offerCategoryName}</div> */}
            <div className="category-name flex-it flex-align-item-center">
              <Text field={props?.props?.routeData?.title} />
            </div>

            <div className="filter-mobile">
              {shouldRenderSorting && (
                <div className="sorting-mobile flex-inline">
                  <SortingComponent
                    items={sorting}
                    isOpen={false}
                    mobileView={true}
                    {...{
                      selectSortValue,
                      setSelectSortValue,
                      selectSortText,
                      setSelectSortText,
                      setAllFilters,
                      t,
                    }}
                  />
                </div>
              )}

              <div
                className="mobile icon_filter flex-inline flex-align-item-center flex-justify-center"
                onClick={() => setMobileFiltersIsToggle((state) => !state)}
              >
                <div className="filter-text">{t('filterTitle')}</div>
                <div className="filter-image">
                  <img src={icon_filterBlue} />
                </div>
                {numberOfFilters > 0 && (
                  <div className="filter-count flex-inline flex-align-item-center flex-justify-center">
                    {numberOfFilters}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="generic-search">
            <FormControl fullWidth sx={{ m: 0 }}>
              <InputLabel htmlFor="outlined-adornment-amount">{t('search')}</InputLabel>
              <OutlinedInput
                inputRef={inputSearchRef}
                onKeyPress={(e) => e.key === 'Enter' && handleKeywordSearchButtonClick(e)}
                onKeyUp={(e) => handleKeyUpOnSearchInput(e)}
                onChange={(e) => handleKeywordChange(e)}
                id="outlined-adornment-amount"
                value={value}
                label={t('search')}
              />
              <div className="icon-search flex-it flex-align-item-center">
                <img src={'/-/jssmedia/Project/FAB2/shared/images/icon_search-blue.svg'} />
              </div>
              <div className={clsx('searchItems-box box-type', isOpen ? 'open' : '')}>
                {dataRetrievedItems?.length > 0 && <div className="arrow-top"></div>}
                {dataRetrievedItems?.length > 0 &&
                  dataRetrievedItems?.slice(0, 6)?.map((item, index) => {
                    let title = item?.item?.title?.value;
                    let subTitle = { value: item?.item?.merchantName?.value };

                    return (
                      <SearchItem
                        item={item}
                        key={index}
                        index={index}
                        searchWord={inputSearchRef?.current?.value}
                        title={title}
                        subTitle={subTitle}
                        focusedIndex={focusedIndex}
                      />
                    );
                  })}

                {dataRetrievedItems?.length > 6 && (
                  <div className="footer-results">
                    <div className="auto">
                      <div className="view-all">
                        <Button
                          onClick={handleKeywordSearchButtonClick}
                          fullWidth={false}
                          color="secondary"
                          variant="contained"
                          arrow="right"
                          className="btn-view-all"
                        >
                          {t('viewAllResults')}
                        </Button>
                      </div>

                      <div className="results-count flex-it flex-align-item-center">
                        <div className="text-count">
                          {t(summaryText).replace('{0}', dataRetrievedItems?.length)}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div
                className={clsx(
                  'no-search-results box-type flex-it flex-align-item-center',
                  wordsNotFoundError ? 'open' : ''
                )}
              >
                {wordsNotFoundError && <div className="arrow-top"></div>}

                <div className="auto flex-it flex-align-item-center">
                  <div className="image-error">
                    <img src={`/-/media/Project/FAB2/shared/images/ico_exclamation-red.svg`} />
                  </div>
                  <div className="text">
                    {t('offerCategoryFilterNoResult').replace('{0}', `'${value}'`)}
                  </div>
                </div>
              </div>
            </FormControl>

            <div
              className={clsx(
                'search-actions flex-it flex-align-item-center',
                value !== '' && value.length >= 5 ? '' : 'disabled'
              )}
            >
              <div className="close-search" onClick={handleCancelSearchClick}>
                <img src={'/-/jssmedia/Project/FAB2/shared/images/ico_closeCircle-blue.svg'} />
              </div>
              <Button
                onClick={handleKeywordSearchButtonClick}
                variant="contained"
                className={clsx('panel-right__link search-btn')}
                fullWidth={false}
              >
                <span className="desktop">{t('search')}</span>
                <span className="mobile">
                  <img src={'/-/jssmedia/Project/FAB2/Fab2/data/media/svgs/icons/search.svg'} />
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="searchItem-category flex-it flex-align-item-center">
        {props?.props?.routeData?.title?.value}
        {props?.count >= 0 && (
          <span className="nb-of-items">
            {props?.count > 1
              ? `${props?.count} ${t('itemsFound')}`
              : `${props?.count} ${t('itemFound')}`}
          </span>
        )}
      </div>
    </>
  );
};

export default SearchComponent;
